module.exports = __webpack_public_path__ + "assets/files/test_product_import.csv";